import { useState, useEffect, useRef, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, ButtonBase, InputBase, Typography , Checkbox as MuiCheckbox } from '@material-ui/core';
import _ from 'lodash';
import * as Yup from 'yup';
import produce from 'immer';
import { connect } from 'react-redux';
import { Prompt, withRouter } from 'react-router-dom';
import Header from '../RosterPlanner/head';
import { AddIcon, AssignIcon, DeleteIcon , EditIcon,} from '../../../../components/Icon';
import rou from '../../../../router';
import { i18n } from '../../../../language';
import { dutyAssignAPI } from '../../../../apis';
import { decodeQuery } from '../../../../utils/url';
import { getInputWidth, onKeyUpEnterOrSpace } from '../../../../utils';
import { Alert } from '../../../../components';
import { SetEdit, SetUnEdit } from '../../../../redux/actions';
import { store } from '../../../../redux';
import { authNameE } from '../../../../utils/userFuncs';
import CreateChatroom from '../../components/TemplateEdit/CreateChatroom';
import { allDataFunc, C, groupDataFunc, templateFunc } from './constant';
import DutyIC from './dutyIC';
import OnDuty from './onDuty';
import { Delete } from './list';
import DndScrooler from './DndScrooler';


const useStyles = makeStyles((theme) => ({
  root: {},
  head: {
    padding: '8.188rem 0 2.063rem 3.438rem',
    backgroundColor: theme.palette.font.white,
  },
  title: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '2.25rem',
    color: '#001d63',
    fontWeight: 'bold',
    '& .MuiInputBase-input': {
      padding: '0',
      height: '3.5rem',
    },
  },
  titleBox: {
    display: 'flex',
    marginBottom: '0.313rem',
  },
  titleIconBox: {
    display: 'flex',
    alignItems: 'center',
  },
  titleIcon: {
    fontSize: '1.563rem',
    margin: '0.2rem 0 0 1rem',
    color: theme.palette.font.main,
    cursor: 'pointer',
  },
  body: {
    padding: '2.438rem 3.438rem 6.063rem',
  },
  foot: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  confirm: {
    width: '12.5rem',
    height: '3rem',
    padding: '0.875rem 1.25rem',
    marginLeft: '1.25rem',
    borderRadius: '0.625rem',
    backgroundColor: '#4c93ff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    fontWeight: '500',
    color: theme.palette.font.white,
    textTransform: 'inherit',
    '&:hover': {
      backgroundColor: '#4c93ff',
    },
  },
  cancel: {
    width: '12.5rem',
    height: '3rem',
    padding: '0.875rem 1.25rem',
    borderRadius: '0.625rem',
    border: '0.09375rem solid #4c93ff',
    backgroundColor: '#f5faff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    fontWeight: '500',
    color: theme.palette.primary.main,
    textTransform: 'inherit',
    '&:hover': {
      backgroundColor: '#f5faff',
    },
  },
  deleteIcon: {
    width: '1.25rem',
    height: '1.25rem',
    color: '#7d86a9',
    marginRight: '0.75rem',
  },
  deleteTemplate: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    fontWeight: '500',
    color: '#7d86a9',
    marginRight: '3.438rem',
  },
  addIcon: {
    width: '1rem',
    height: '1rem',
    marginRight: '0.313rem',
  },
   batchPublishButton: {
    // width: '8.875rem',
    width: '10.25rem',
    border: 'solid 1px #538fff',
    height: '3rem',
    borderRadius: '10px',
    backgroundColor: '#f5faff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    fontWeight: '500',
    color: theme.palette.primary.main,
    // padding: '0 2.5rem 0 1.625rem',
    padding: '0 .7rem',
  },

}));

function TemplateEdit({ location, history, editFlag, setEdit, setUnEdit }) {
  const classes = useStyles();
  const query_id = decodeQuery(location.search)?.id;
  const [templateList, setTemplateList] = useState(null);
  const titleRef = useRef(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState({});
  const [icAlertOpen, setICAlertOpen] = useState(false);
  const [enableSmartComm, setEnableSmartComm] = useState(0);
  const [hasDutyChatValue, setHasDutyChatValue] = useState(false);
  const [hasSmartCount, setHasSmartCount] = useState(false);
  const [openSetupChatroom, setOpenSetupChatroom] = useState(false);
  const [alertInfo, setAlertInfo] = useState(null);
  const handleEdit = (props) => {
    props ? setEdit() : setUnEdit();
  };

  const dutyICSchema = {
    [i18n.t('DUTYASSIGN_TEMPLATE_DUTYIC')]: Yup.string().required(
      i18n.t('DUTYASSIGN_TEMPLATE_AUTORULE_ERROR', { value: i18n.t('DUTYASSIGN_TEMPLATE_DUTYIC') })
    ),
  };

  const checkData = async (schema, data) => {
    try {
      await schema.validate(data, {
        abortEarly: false,
      });
    } catch (err) {
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          if (error.path !== undefined) {
            validationErrors[error.path] = error.message;
          }
        });
      }
      throw validationErrors;
    }
  };

  const focusCheck = (value, data, id) => {
    return async () => {
      try {
        await checkData(Yup.object().shape({ [value]: dutyICSchema[value] }), {
          [value]: data,
        });
        let temp = errorMsg;
        delete temp[id];
        setErrorMsg({ ...temp });
      } catch (e) {
        setErrorMsg({ ...errorMsg, [id]: { ...e } });
      }
    };
  };

  // getTemplateAPI
  const getTemplateAPI = async () => {
  try {
    const { result } = await dutyAssignAPI.getMyTemplate({ templateWardId: query_id });
    const { result: smartCount } = await dutyAssignAPI.getMyTemplateSmartCount({ templateWardId: query_id });


    let orderedList = templateFunc.order(allDataFunc.getTemplateData(result, query_id));

    setEnableSmartComm(orderedList.isSmartCommunication);
    
    if (hasAnyDutyChatTime(result) || smartCount > 0) {
      orderedList = {
        ...orderedList,
        isSmartCommunication: 1   // force the flag at root
      };
      setHasDutyChatValue(true);
      setEnableSmartComm(true);
      setHasSmartCount(true)
    }

    setTemplateList(orderedList);
  } catch (error) {
    console.log('-----Get Template error----->', error);
  }
};


  useEffect(() => {
    templateFunc.resetDeleteIds();
    (async () => {
      if (query_id === undefined) {
        setTemplateList(templateFunc.initTemplateDate());
        
      } else {
        await getTemplateAPI();
      }
    })();
  }, [query_id]);

  useEffect(() => { 
    if (templateList) 
      { 
        if(!hasSmartCount)
        setHasDutyChatValue(hasAnyDutyChatTime(templateList));
    
      }

  }, [templateList]);

  const confirmHandle = (template) => {
    return async () => {
      try {
        const newTemplateList = templateFunc.mergeAllDelete(template);
        if (newTemplateList.templateName.length === 0) {
          setAlertOpen(true);
          return;
        }
        if (Object.keys(errorMsg).length > 0) {
          setICAlertOpen(true);
          return;
        }
        console.log('newTemplateList=', newTemplateList);
        await dutyAssignAPI.postCreateDaDutyTemplate(newTemplateList);
        handleEdit(false);
        history.replace(rou.TemplateRou.path);
      } catch (error) {
        console.log(error);
      }
    };
  };

  const updateGroup = (index) => {
    return (groupData) => {
      setTemplateList(templateFunc.setGroup(templateList, index, groupData));
      handleEdit(true);
      if(!hasSmartCount){
        setHasDutyChatValue(hasAnyDutyChatTime(templateList));
      }
    };
  };

  const delectGroup = (index) => {
    return () => {
      setTemplateList(templateFunc.delectGroup(templateList, index));
      handleEdit(true);
      if(!hasSmartCount){
        setHasDutyChatValue(hasAnyDutyChatTime(templateList));
      }
    };
  };

  const triggerFunction = (index) => {
    return (preIndex, nextIndex) => {
      handleEdit(true);
      setTemplateList(
        produce((templateList) => {
          const groupData = templateList.rosterGroups[index];
          const allFunc = groupData.functionalAreas;
          const preData = allFunc.splice(preIndex, 1);
          allFunc.splice(nextIndex, 0, ...preData);
          allFunc.forEach((item, index) => {
            item.areaOrder = index;
          });
        })
      );
      if(!hasSmartCount){
        setHasDutyChatValue(hasAnyDutyChatTime(templateList));
      }
    };
  };

  const [ISDeleteTemplatePop, setISDeleteTemplatePop] = useState(false);
  const deleteTemplateHandle = () => {
    setISDeleteTemplatePop(true);
  };

  useMemo(() => {
    if (templateList !== null && templateList !== undefined && titleRef.current) {
      const inputWidth = getInputWidth(templateList[C.templateName], '2.25rem');
      titleRef.current.style.width = `${inputWidth}px`;
    }
  }, [templateList]);



  const handleEnableSmartComm = () => {
    
    const newValue = enableSmartComm === 0 || enableSmartComm===undefined  ? 1 : 0;
    setEnableSmartComm(newValue);
    setTemplateList(templateFunc.setIsSmartCommunication(templateList, newValue));
    handleEdit(true);
  };


  const hasAnyDutyChatTime = (dutyTemplates) => {
    if (!dutyTemplates) return false;

    const templates = Array.isArray(dutyTemplates) ? dutyTemplates : [dutyTemplates];

    const hasChatTimeOrShift = (area) => {
      const {
        chatStartAt,
        chatEndAt,
        chatBufferEnterAt,
        chatBufferLeaveAt,
        dutyChats = [],
        templateMappings = [],
      } = area;

      const hasChat =
        chatStartAt !== null && chatStartAt !== undefined ||
        chatEndAt !== null && chatEndAt !== undefined ||
        chatBufferEnterAt !== null && chatBufferEnterAt !== undefined ||
        chatBufferLeaveAt !== null && chatBufferLeaveAt !== undefined ||
        (Array.isArray(dutyChats) && dutyChats.length > 0);

      const hasShift = templateMappings.some(mapping =>
        Array.isArray(mapping.staffs) && mapping.staffs.some(staff =>
          (staff.shift_date && staff.shift_date !== '') ||
          (staff.shift_start_time && staff.shift_start_time !== '') ||
          (staff.shift_end_time && staff.shift_end_time !== '')
        )
      );

      return hasChat || hasShift;
    };

    return templates.some(template =>
      Array.isArray(template.rosterGroups) &&
      template.rosterGroups.some(group =>
        Array.isArray(group.functionalAreas) &&
        group.functionalAreas.some(hasChatTimeOrShift)
      )
    );
  };


  const scrollRefs = useRef({});

  const roleMap = store.getState()?.roleMap || {};

  const SmartCheckbox = ({ check, handleChange, id, open, disabled }) => {
    return (
      <MuiCheckbox
        checked={check}
        onChange={handleChange}
        id={id}
        disabled={disabled}  
        color="primary"
      />
    );
  };

  return (
    <>
      <Alert
        open={alertOpen}
        id="DutyAssign-Alert-agk"
        text={i18n.t('DUTYASSIGN_TEMPLATE_SAVE_ALERT')}
        type="warning"
        onClose={() => setAlertOpen(false)}
      />
      <Alert
        open={icAlertOpen}
        id="DutyAssign-Alert-agl"
        text={i18n.t('DUTYASSIGN_TEMPLATE_SAVE_IC_ALERT')}
        type="warning"
        onClose={() => setICAlertOpen(false)}
      />
      <Prompt
        when={editFlag}
        id="DutyAssign-Prompt-agm"
        message={JSON.stringify({
          header: i18n.t('DUTYASSIGN_NOT_SAVE_TITLE'),
          content: i18n.t('DUTYASSIGN_NOT_SAVE_BODY'),
        })}
      />
      {ISDeleteTemplatePop ? (
        <Delete
          open={ISDeleteTemplatePop}
          id="DutyAssign-Delete-agn"
          headerTitle={i18n.t('DUTYASSIGN_DELETE_TEMPLATE')}
          setopen={setISDeleteTemplatePop}
          content={i18n.t('DUTYASSIGN_DELETE_TEMPLATE_BODY')}
          handleDelete={() => {
            (async () => {
              await confirmHandle(templateFunc.deleteTemplate(templateList))();
            })();
            setISDeleteTemplatePop(false);
          }}
        />
      ) : (
        ''
      )}
      <DndScrooler scrollRefs={scrollRefs} />
      <div className={classes.root}>
        <Header path={rou.TemplateRou.path} text={i18n.t('DUTYASSIGN_BACK')} id="DutyAssign-Template-back" />
        <div className={classes.head}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box className={classes.titleBox}>
              <InputBase
                ref={titleRef}
                className={classes.title}
                value={templateFunc.getTemplateName(templateList)}
                onChange={(event) => {
                  setTemplateList(templateFunc.setTemplateName(templateList, event.target.value));
                  handleEdit(true);
                }}
                id="DutyAssign-InputBase-ago"
                // onBlur={() => {
                //   if (!editOpen) {
                //     setEditOpen(!editOpen);
                //   }
                // }}
              />
              <div
                className={classes.titleIconBox}
                onClick={() => {
                  titleRef.current.querySelector('input').focus();
                }}
                id="DutyAssign-div-agp"
                tabIndex={0}
                onKeyUp={(e) =>
                  onKeyUpEnterOrSpace(e, () => {
                    titleRef.current.querySelector('input').focus();
                  })
                }
              >
                <AssignIcon className={classes.titleIcon} />
              </div>
            </Box>

            <Box display="flex" justifyContent="flex-end" alignItems="center" sx={{ marginTop: '10px' }} marginRight='0.5rem'>

              {roleMap?.[authNameE.dutyAssign_Enable_Smart_Communication] && (
                <Box display="flex" alignItems="center" sx={{ gap: '0.3rem' }}>
                  <SmartCheckbox
                    check={Boolean(enableSmartComm)}
                    id="esc"
                    handleChange={handleEnableSmartComm}
                    disabled={hasDutyChatValue}
                  />
                  <div style={{ fontSize: '1rem', marginRight:'3rem' }}>Enable Smart Communication</div>
                </Box>
              )}

              {(Boolean(enableSmartComm) || roleMap[authNameE.setting_view_Ward_Chatroom_Setup]) && (
                  <ButtonBase
                    onClick={() => setOpenSetupChatroom(true)}
                    id="DutyAssign-Template-ButtonBase-setupChatroom"
                  >
                    <EditIcon className={classes.deleteIcon} /> 
                    <Typography className={classes.deleteTemplate}>
                      {i18n.t('DUTYASSIGN_CREATE_CHATROOM_MENU')}
                    </Typography>
                  </ButtonBase>
                )}

              {query_id ? (
              <ButtonBase onClick={deleteTemplateHandle} id="DutyAssign-ButtonBase-agq">
                <DeleteIcon className={classes.deleteIcon} />
                <Typography className={classes.deleteTemplate}>{i18n.t('DUTYASSIGN_DELETE_TEMPLATE')}</Typography>
              </ButtonBase>
            ) : (
              ''
            )}

            </Box>

       
          </Box>
        </div>
        <div className={classes.body}>
          {_.map(templateFunc.getAllGroup(templateList), (item, index) => {
            const Com = groupDataFunc.isDutyIC(item) ? DutyIC : OnDuty;
            return (
              <Com
                allData={item}
                focusCheck={focusCheck}
                errorMsg={errorMsg}
                updateGroup={updateGroup(index)}
                id={`DutyAssign-Com-agr-${index}`}
                delectGroup={delectGroup(index)}
                key={groupDataFunc.getGroupId(item)}
                triggerFunction={triggerFunction(index)}
                smartComm={enableSmartComm}
                ref={(ref) => {
                  scrollRefs.current[groupDataFunc.getGroupId(item)] = ref;
                }}
                
              />
            );
          })}
          <div className={classes.foot}>
            <Box display="flex">
              {templateList && templateFunc.isDeletedGroupType(templateList, 1) ? (
                <Button
                  className={classes.confirm}
                  style={{ width: '10.188rem' }}
                  onClick={() => {
                    setTemplateList(templateFunc.addGroupUseType(templateList, 1));
                    handleEdit(true);
                  }}
                  id="DutyAssign-Button-ags"
                >
                  <AddIcon className={classes.addIcon} /> Duty IC
                </Button>
              ) : (
                <div />
              )}
              {templateList ? (
                <Button
                  className={classes.confirm}
                  style={{ width: '10.188rem' }}
                  onClick={() => {
                    setTemplateList(templateFunc.addGroupUseType(templateList, 2));
                    handleEdit(true);

                  }}
                  id="DutyAssign-Button-agt"
                >
                  <AddIcon className={classes.addIcon} /> On Duty
                </Button>
              ) : (
                <div />
              )}
              {templateList && templateFunc.isDeletedGroupType(templateList, 3) ? (
                <Button
                  className={classes.confirm}
                  style={{ width: '10.188rem' }}
                  onClick={() => {
                    setTemplateList(templateFunc.addGroupUseType(templateList, 3));
                    handleEdit(true);
                  }}
                  id="DutyAssign-Button-agu"
                >
                  <AddIcon className={classes.addIcon} /> Leave
                </Button>
              ) : (
                <div />
              )}
            </Box>

            <Box display="flex">
              <Button className={classes.cancel} onClick={() => history.goBack()} id="DutyAssign-Button-cancel-agv">
                {i18n.t('DUTYASSIGN_CANCEL')}
              </Button>
              <Button
                className={classes.confirm}
                onClick={() => {
                  (async () => {
                    await confirmHandle(templateList)();
                  })();
                }}
                id="DutyAssign-Button-confirm-agv"
                style={{
                  opacity:
                    templateList && templateFunc.mergeAllDelete(templateList).templateName.length === 0 ? 0.2 : 1,
                }}
              >
                {i18n.t('DUTYASSIGN_CONFIRM')}
              </Button>
            </Box>

          {openSetupChatroom && (
                    <CreateChatroom
                      closePop={() => {
                        setOpenSetupChatroom(false);
                      }}
                      open={openSetupChatroom}
                      title={i18n.t('DUTYASSIGN_CREATE_CHATROOM_TITLE')}
                      setAlertInfo={setAlertInfo}
                    />
                  )}

          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  editFlag: state.dutyEditFlag,
});

const mapDispatchToProps = (dispatch) => ({
  setEdit: () => {
    dispatch(SetEdit());
  },
  setUnEdit: () => {
    dispatch(SetUnEdit());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TemplateEdit));
